// extracted by mini-css-extract-plugin
export default {"nameInput":"SectionNameDialog_nameInput__oCnUx"};